import React from 'react';
import { NavLink } from 'react-router-dom';
import { translate } from 'react-i18next';

import NewsletterHeader from './NewsletterHeader';

const AdminHeader = ({
  t,
  title,
  subtitle,
  nextUpdate,
  daysToNextUpdate,
  isDueDatePassed,
}) => (
  <React.Fragment>
    <NewsletterHeader
      title={title}
      subtitle={subtitle}
      nextUpdate={nextUpdate}
      daysToNextUpdate={daysToNextUpdate}
    />
    {/* Tabs */}
    <div className="c-tabs">
      <div className="o-wrapper o-wrapper--small">
        <nav className="c-tabs-nav u-text-center u-display-flex">
          <NavLink
            activeClassName="is-active"
            to="/admin/invites"
            className="u-padding c-tabs-nav__link c-tabs-nav__link"
          >
            {t('admin.invites')}
          </NavLink>
          <NavLink
            activeClassName="is-active"
            to="/admin/settings"
            className="u-padding c-tabs-nav__link"
          >
            {isDueDatePassed ? '❗' : ''} {t('admin.settings')}
            <div />
          </NavLink>
        </nav>
      </div>
    </div>
  </React.Fragment>
);

export default translate()(AdminHeader);



// WEBPACK FOOTER //
// ./src/common/AdminHeader.js